import { Lightbulb, FlaskConical, Timer, Truck } from "lucide-react";
import { useLang } from "../i18n";
import { IMG } from "../data/site";
import Seo, { breadcrumbLd } from "../components/Seo";
import { Reveal, Kicker, MaskLine } from "../components/Reveal";

export default function CenterPage() {
  const { lang, t } = useLang();
  const prefix = lang === "ca" ? "/ca" : "";

  return (
    <div data-testid="center-page" className="pt-32">
      <Seo
        title={t("seo.center.title")}
        desc={t("seo.center.desc")}
        path="/nuestro-centro"
        jsonLd={breadcrumbLd([
          { name: "EcoGlow Detailing", path: prefix || "/" },
          { name: t("nav.center"), path: `${prefix}/nuestro-centro` },
        ])}
      />
      <section className="relative flex min-h-[60svh] items-end overflow-hidden">
        <img src={IMG.heroDark} alt={t("center.title")} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/60 to-[#050505]/30" />
        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-16 sm:px-6 lg:px-12">
          <Reveal><Kicker>{t("center.kicker")}</Kicker></Reveal>
          <h1 className="mt-4 max-w-3xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl">
            <MaskLine delay={0.1}>{t("center.title")}</MaskLine>
          </h1>
          <Reveal delay={0.3}>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-zinc-300">{t("center.sub")}</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-12 lg:py-28">
        <div className="grid gap-14 lg:grid-cols-2">
          <div className="space-y-6">
            <Reveal><p className="text-base leading-relaxed text-zinc-300">{t("center.body1")}</p></Reveal>
            <Reveal delay={0.1}><p className="text-base leading-relaxed text-zinc-300">{t("center.body2")}</p></Reveal>
            <Reveal delay={0.15}>
              <div className="flex items-start gap-4 rounded-xl border border-[#63E51D]/25 bg-[#101508] p-6">
                <Truck className="mt-1 h-6 w-6 shrink-0 text-[#63E51D]" />
                <p className="text-sm leading-relaxed text-zinc-200">{t("center.pickup")}</p>
              </div>
            </Reveal>
          </div>
          <div className="space-y-5">
            {[
              { icon: Lightbulb, t: t("center.f1t"), d: t("center.f1d") },
              { icon: FlaskConical, t: t("center.f2t"), d: t("center.f2d") },
              { icon: Timer, t: t("center.f3t"), d: t("center.f3d") },
            ].map((f, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="flex items-start gap-5 rounded-xl border border-white/5 bg-[#121212] p-6 transition-all duration-300 hover:border-[#63E51D]/40">
                  <span className="rounded-full bg-[#63E51D]/10 p-3 text-[#63E51D]"><f.icon className="h-5 w-5" /></span>
                  <div>
                    <h2 className="font-display text-xl font-bold uppercase tracking-wide text-white">{f.t}</h2>
                    <p className="mt-1 text-sm leading-relaxed text-zinc-400">{f.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
